var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.936,
    height: 20.818,
    viewBox: "0 0 18.936 20.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-trash-2",
    "data-name": "Icon feather-trash-2",
    d: "M4,6.43H20.936m-1.882,0V19.6a1.882,1.882,0,0,1-1.882,1.882H7.764A1.882,1.882,0,0,1,5.882,19.6V6.43m2.823,0V4.548a1.882,1.882,0,0,1,1.882-1.882H14.35a1.882,1.882,0,0,1,1.882,1.882V6.43m-5.645,4.7V16.78m3.764-5.645V16.78",
    transform: "translate(-3 -1.667)",
    fill: "none",
    stroke: "#ef446e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.6d2846ac.svg";
export { ForwardRef as ReactComponent };